import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import FormDialog from '../panel/modal';
import { useNavigate } from 'react-router-dom';
import Loader from '../panel/loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SearchIcon from '@mui/icons-material/Search';

import api from '../../API/api';

import GeneralAction from '../panel/generalAction';

const StudentTable = (props) => {

    const date = new Date();

    const [students, setStudents] = useState();
    const [schools, setSchools] = useState();
    const [courses, setCourses] = useState();
    const [load, setLoad] = useState();
    const [copyStudent, setCopyStudent] = useState();
    const [filerStudent, setFilterStudent] = useState();
    const [schId, setSchId] = useState();
    const [batch, setBatch] = useState(date.getFullYear());
    const [search, setSearch] = useState();

    const [buttonActive, setButtonActive] = useState('active');

    const [selectedData, setSelectedData] = useState(
        {
            school: '',
            course: '',
            batch: '2023'
        }
    )

    const handleSelected = (e) => {
        setSelectedData({
            ...selectedData,
            [e.target.name]: e.target.value
        })
    }


    useEffect(() => {
        // setLoad(true)
        getSchool();
        getStudents();
        // setLoad(false)
    }, [props.refresh]);



    const getSchool = () => {
        setLoad(true)
        api.getSchools().then((res) => {
            // console.log(res);
            setSchools(res.data.schools)
            setLoad(false)
        })
            .catch((err) => {
                // console.log(err.response);
                setLoad(false)
            })
    }

    const getCourse = (data) => {
        setLoad(true)
        api.getCourses(data).then((res) => {
            setCourses(res.data.courses)
            // console.log(res);
            setLoad(false)
        })
            .catch((err) => {
                // console.log(err.response);
                setLoad(false)
            })
    }


    const getStudents = () => {
        setLoad(true)
        api.getStudents().then((res) => {
            // console.log(res);
            setLoad(false)
            setStudents(res.data.students);
            setFilterStudent(res.data.students.filter((el) => el.isApprove == 1).filter((tl) => tl.batch == batch))
            setCopyStudent(res.data.students)
        })
            .catch((err) => {
                setLoad(false)
                // console.log(err.response);
            })
    }

    const filterStudent = (type, e) => {
        // console.log(type, e.target.value);
        // primary filter 
        if (type === 'school') {
            if (e.target.value) {
                getCourse(e.target.value)
                setFilterStudent(students.filter((el) => el.school_id == e.target.value))
                setCopyStudent(students.filter((el) => el.school_id == e.target.value))
                setSchId(e.target.value)
            }
            else {
                // getCourse(e.target.value)
                setFilterStudent(students)
                setCopyStudent(students)
            }
        }

        if (type === 'course') {
            if (e.target.value) {
                setFilterStudent(students.filter((el) => el.course_id == e.target.value))
                setCopyStudent(students.filter((el) => el.course_id == e.target.value))
            }
            else {
                setFilterStudent(students.filter((el) => el.school_id == schId))
                setCopyStudent(students.filter((el) => el.school_id == schId))
            }
        }
        setButtonActive('all')

    }


    const subFilter = (type, e) => {
        if (type === 'batch') {
            setBatch(e.target.value)
            setFilterStudent(copyStudent.filter((el) => el.batch == e.target.value))
            setButtonActive('all')
        }


        if (type === 'all') {
            // console.log('all');
            setFilterStudent(copyStudent)
            setButtonActive('all')
            setBatch('')
        }
        if (type === 'active') {
            if (batch) {
                setFilterStudent(copyStudent.filter((el) => el.isApprove == '1').filter((tl) => tl.batch == batch))
            } else {
                setFilterStudent(copyStudent.filter((el) => el.isApprove == '1'))
            }
            setButtonActive('active')
        }
        if (type === 'request') {
            if (batch) {
                setFilterStudent(copyStudent.filter((el) => el.isApprove == '0').filter((tl) => tl.batch == batch))
            } else {
                setFilterStudent(copyStudent.filter((el) => el.isApprove == '0'))
            }
            setButtonActive('request')
        }
    }



    const searchStudent = () => {
        setLoad(true)
        setButtonActive('all')
        api.searchStudent(search).then((res) => {
            // console.log("res", res);
            setLoad(false)
            setFilterStudent(res.data.searchData)
            setCopyStudent(res.data.searchData)
        })
            .catch((err) => {
                // console.log(err);
                setLoad(false)
            })
    }


    return (
        <div className='mt-2 m-0 p-0'>
            {load &&
                <Loader />
            }
            <Paper>

                <div className='row p-3'>
                    <div className="col-md-5">

                        <div className="d-flex align-items-center">
                            <div className='px-2'>
                                School
                            </div>

                            <select name="course" onChange={(e) => filterStudent('school', e)} className='form-control p-0 px-2' id="">
                                <option value="">All</option>
                                {schools && schools.map((s) => (
                                    <option value={s.id}>{s.schoolName}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-5">

                        <div className="d-flex align-items-center">
                            <div className='px-2'>
                                Course
                            </div>

                            <select name="course" onChange={(e) => filterStudent('course', e)} className='form-control p-0 px-2' id="">
                                <option value="">All</option>
                                {courses && courses.map((c) => (
                                    <option value={c.id}>{c.shortName} -- ({c.effected_from} - {c.effected_to})</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-2">

                        <div className="d-flex align-items-center">
                            <div className='px-2'>
                                Batch
                            </div>

                            <select name="course" value={batch} onChange={(e) => subFilter('batch', e)} className='form-control p-0 px-2' id="">
                                <option value="">All</option>
                                <option value='2020'>2020</option>
                                <option value='2021'>2021</option>
                                <option value='2022'>2022</option>
                                <option value='2023'>2023</option>
                                <option value='2024'>2024</option>
                            </select>
                        </div>
                    </div>
                </div>


                <div className='px-3 pb-3 d-flex justify-content-between'>
                    <div>
                        <Button variant={buttonActive !== 'all' ? 'outlined' : 'contained'} size='small' onClick={(e) => subFilter('all', e)}>All</Button> &nbsp;
                        <Button variant={buttonActive !== 'active' ? 'outlined' : 'contained'} color="secondary" onClick={(e) => subFilter('active', e)} size='small'>Active</Button> &nbsp;
                        <Button variant={buttonActive !== 'request' ? 'outlined' : 'contained'} size='small' onClick={(e) => subFilter('request', e)}>
                            Request
                            <span className='text-danger'>
                                ({students?.filter((el) => el.isApprove == '0').length})
                            </span>
                        </Button> &nbsp;
                    </div>

                    <div className='d-flex'>
                        <input type="text" name="" id="" onChange={(e) => setSearch(e.target.value)} value={search} className='form-control p-1 px-3' placeholder='Search With Registration' />
                        <Button variant='outlined' size='small' onClick={searchStudent}><SearchIcon /></Button>
                    </div>

                </div>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead sx={{ backgroundColor: 'black' }}>
                            <TableRow>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }}>Name</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Roll No</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Registration No</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >School</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Course</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Batch</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} >Status</TableCell>
                                <TableCell sx={{ color: 'white', fontWeight: '800', padding: '15px' }} align="right">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {load && <Loader />}
                            {filerStudent && filerStudent.map((row) => (
                                <TableRow
                                    key={row.registration}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell className={` ${row.isApprove ? 'text-success' : 'text-danger'} `}> <strong> {row.name} </strong> </TableCell>
                                    <TableCell className={` ${row.isApprove ? 'text-success' : 'text-danger'} `}>{row.enrollment}</TableCell>
                                    <TableCell className={` ${row.isApprove ? 'text-success' : 'text-danger'} `}>{row.registration}</TableCell>
                                    <TableCell className={` ${row.isApprove ? 'text-success' : 'text-danger'} `}>{row.school} </TableCell>
                                    <TableCell className={` ${row.isApprove ? 'text-success' : 'text-danger'} `}>{row.shortName} </TableCell>
                                    <TableCell className={` ${row.isApprove ? 'text-success' : 'text-danger'} `}>{row.batch} </TableCell>
                                    <TableCell >
                                        {row.status === 0 && <span className='text-danger'>Not Approved </span>}
                                        {row.status === 1 && <span className='text-success'> Active </span>}
                                        {row.status === 2 && <span className='text-danger'> Failed </span>}
                                        {row.status === 3 && <span className='text-warning'> Drop-out </span>}
                                        {row.status === 4 && <span className='text-secondary'> Other </span>}
                                    </TableCell>
                                    <TableCell align="right">
                                        <Button size='small' >
                                            <GeneralAction type={'student'}
                                                data={row}
                                                handleClickOpen={props.studentModalOpen}
                                                handleClose={props.studentModalClose}
                                                setModalData={props.setModalData}
                                                handleStatusModal={props.handleStatusModal}
                                                handleViewOpen={props.handleViewOpen}
                                                handleAchivement={props.handleAchivement}
                                                getStudents={getStudents}
                                                deleteStudent={props.deleteStudent}
                                            />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </div>
    )
}

export default StudentTable;